import type { BoardHistoryTab } from "@/store/activity";
import type { DateFilter } from "@/store/helpers/activityDateFilters";

import type { AnalyticsData } from "../types";
import { webEvent } from "./event";

const event = (name: string, data?: AnalyticsData) => webEvent("board_history", name, data);

// Triggered when the user opens a sticky note diff
export const boardHistoryItemOpened = (tab: BoardHistoryTab) => event("item_opened", { tab });

// Triggered when the user closes a sticky note diff
export const boardHistoryItemClosed = (tab: BoardHistoryTab) => event("item_closed", { tab });

// Triggered when the user changes the timespan in the board diff dropdown
export const boardHistoryTimespanChanged = (timespan: DateFilter["id"], tab: BoardHistoryTab) =>
  event("timespan_changed", { timespan, tab });

// Triggered when the user changes the iteration/type/change-type filter
export const boardHistoryFilterChanged = ({
  filterName,
  selectedValues,
  tab,
}: {
  filterName: "iteration" | "sticky-type" | "change-type";
  selectedValues: string[];
  tab: BoardHistoryTab;
}) => event("filter_changed", { filterName, selectedValues, tab });

// Triggered when the user changes between log & compare tabs
export const boardHistoryTabChanged = (tab: BoardHistoryTab) => event("tab_changed", { tab });
